<template>
  <div class="col-12">
    <div class="dropzone-wrapper" :class="{'dropzone-wrapper--compact': compact}">
      <div class="dropzone p-3">
        <div v-bind="getRootProps()"
             class="d-flex align-items-center justify-content-center flex-column hover-pointer inner p-2">
          <input v-bind="getInputProps()"/>
          <template v-if="assetData.length">
            <div class="d-flex flex-wrap justify-content-start w-100 mt-2 upload-previews">
              <template v-for="(asset, index) in assetData" v-bind:key="index">
                <div class="upload-preview p-2">
                  <div class="upload-fieldset position-relative uploaded">
                    <VuePdfEmbed :page="1" :source="asset.url" v-if="asset.file.type === 'application/pdf'"/>
                    <div v-else :style="`background-image: url(${asset.url})`" class="img-preview">
                    </div>
                    <button type="button" class="remove-file btn btn-light btn-sm" @click.stop="removeFile(index)" aria-label="Datei entfernen">
                      <Icon icon="fa-pro-solid:xmark" />
                    </button>
                  </div>
                  <div class="mt-2">
                    <label class="w-100">
                      <span class="form-label small mb-1">Name / Alternativtext</span>
                      <input v-model="asset.altText" class="form-control form-control-sm" @click.stop="ignoreDropZone">
                    </label>
                  </div>
                  <div class="mt-2">
                    <label class="w-100">
                      <span class="form-label small mb-1">Copyright</span>
                      <input v-model="asset.copyright" class="form-control form-control-sm" @click.stop="ignoreDropZone">
                    </label>
                  </div>
                </div>
              </template>
            </div>
          </template>
          <template v-else>
            <p class="text-center dropzone-title">
              <strong>Dateien hier ablegen</strong>
              <span class="d-block small mt-1">oder direkt vom Gerät auswählen</span>
            </p>
            <p class="icon-wrapper">
              <button class="btn btn-outline-primary mt-2" type="button">
                <Icon icon="fa-pro-solid:file-arrow-up" />
                Dateien auswählen
              </button>
            </p>
            <p class="text-center hint">
              Erlaubte Formate: {{this.acceptFiles.join(", ")}}
            </p>
          </template>
        </div>
        <template v-if="mediaLibraryMode">
          <div v-if="assetData.length" class="row mt-3 align-items-center">
            <div class="col-12 col-lg-8 mb-3 mb-lg-0">
              <label class="d-flex gap-2 align-items-start">
                <input class="form-check-input mt-1" type="checkbox" v-model="copyright_confirmed">
                Ich verfüge über die nötigen (Bild-)Rechte an den hochgeladen Dateien und stimme einer Veröffentlichung zu.
              </label>
              <span role="alert" class="mt-1 d-block invalid-feedback" v-if="!copyright_confirmed">Bitte bestätigen Sie die Bildrechte um eine Datei hochzuladen.</span>
            </div>
            <div class="col-12 col-lg-4">
              <div class="d-flex justify-content-end">
                <button class="btn btn-link me-2" type="button" @click="abort" :disabled="uploading">Verwerfen</button>
                <button class="btn btn-success" type="button" @click="upload" :disabled="!copyright_confirmed || uploading">
                  <span v-if="uploading" class="spinner-border spinner-border-sm me-2" aria-hidden="true"></span>
                  {{ uploading ? 'Wird hochgeladen ...' : `${assetData.length} Datei(en) hochladen` }}
                </button>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import {useDropzone} from "vue3-dropzone";
// import axios from "axios";
import {v4 as uuidv4} from 'uuid';
import VuePdfEmbed from 'vue-pdf-embed'

export default {
  name: "DropZone",
  data() {
    return {
      getRootProps: null,
      getInputProps: null,
      uploadEnabled: false,
      copyright_confirmed: false,
      files: [],
      assetData: [],
    }
  },
  components: {
    VuePdfEmbed
  },
  props: {
    mediaLibraryMode: {
      type: Boolean,
      default: true,
    },
    acceptFiles: {
      type: Array,
      default: () => [
        '.jpg',
        '.jpeg',
        '.png',
        '.gif',
        '.webp',
        '.svg',
        '.pdf',
      ],
    },
    multiple: {
      type: Boolean,
      default: () => true
    },
    compact: {
      type: Boolean,
      default: false,
    },
    uploading: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    return {};
  },
  created() {
    const options = {
      multiple: this.multiple,
      accept: this.acceptFiles,
      onDrop: this.onDrop
    }
    const {getRootProps, getInputProps} = useDropzone(options);
    this.getRootProps = getRootProps
    this.getInputProps = getInputProps
  },
  beforeUnmount() {
    this.revokePreviewUrls()
  },
  methods: {
    reset() {
      this.revokePreviewUrls()
      this.files = []
      this.assetData = []
      this.copyright_confirmed = false
    },
    onDrop(acceptFiles) {
      const existingFiles = new Set(this.files.map((file) => this.fileKey(file)))
      const newFiles = acceptFiles.filter((file) => !existingFiles.has(this.fileKey(file)))

      const newAssetData = newFiles.map((file) => {
        file.uuid = uuidv4();
        return {
          file,
          url: URL.createObjectURL(file),
          altText: this.captionFromFileName(file.name),
          copyright: '',
          copyright_confirmed: true,
          uuid: file.uuid,
        }
      })

      this.files.push(...newFiles)
      this.assetData.push(...newAssetData)
      this.$emit('onDrop', newFiles)
    },
    ignoreDropZone() {
    },
    captionFromFileName(filename) {
      if (filename) {
        const fileWithoutExtension = filename.replace(/\.[^/.]+$/g, "")
        return fileWithoutExtension.replaceAll(/[._-]/g, ' ');
      }
    },
    abort() {
      this.reset()
      this.$emit('abort')
    },
    removeFile(index) {
      URL.revokeObjectURL(this.assetData[index].url)
      this.files.splice(index, 1)
      this.assetData.splice(index, 1)
      if (!this.files.length) {
        this.copyright_confirmed = false
      }
    },
    revokePreviewUrls() {
      this.assetData.forEach((asset) => URL.revokeObjectURL(asset.url))
    },
    fileKey(file) {
      return `${file.name}:${file.size}:${file.lastModified}:${file.type}`
    },
    upload() {
      this.$emit('upload', this.assetData)
    },

  }
};
</script>

<style scoped lang="scss">
@import "src/scss/constants";
.img-preview {
  height: 130px;
  width: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.img-fluid-fit {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}
.dropzone-wrapper {
  background: white;
  border: 1px solid $border_gray;

  .dropzone {
    //box-shadow: 0 0 6px #00000029;
    color: black;
    min-height: 100px;
    .inner {
      border: 2px dashed #9eb3c5;
      border-radius: 8px;
      background: #f7fafc;
      min-height: 150px;
      transition: border-color 0.2s, background-color 0.2s;

      &:hover {
        border-color: $manet_blue;
        background: #f1f7fb;
      }
    }
    p {
      margin: 0;
      padding: 0;
    }

    .icon-wrapper {
      font-size: 1rem;
    }

    .hint {
      font-size: 0.75rem;
      color: #607386;
    }

    .status {
      background: rgba(255, 255, 255, 0.5);
      width: 100%;
      height: 100%;
      display: none;

      i {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 5rem;
      }
    }

    .uploaded {
      .status {
        display: block;
      }
    }
  }

  &--compact .dropzone .inner {
    min-height: 120px;
  }
}

.upload-previews {
  gap: 0.75rem;
}

.upload-preview {
  width: min(220px, 100%);
  background: white;
  border: 1px solid $border_gray;
  border-radius: 6px;
}

.upload-fieldset {
  overflow: hidden;
  border-radius: 4px;
}

.remove-file {
  position: absolute;
  right: 0.4rem;
  top: 0.4rem;
  width: 30px;
  height: 30px;
  padding: 0;
  border-radius: 50%;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
}
</style>
